export default __webpack_public_path__ + "static/media/publish_plan.fae5b046.png";